import MainImageBlockView from './View';
import MainImageBlockEdit from './Edit';
import { MainImageSchema } from './schema';
import imageSVG from '@plone/volto/icons/image.svg';
import type { BlockConfigBase } from '@plone/types';

export interface MainImageBlockData {
  align?: string;
  title?: string;
  description?: string;
  altText?: string;
  position?: 'left' | 'center' | 'right' | 'full';
  size?: 's' | 'm' | 'l';
  styles?: any;
}

const MainImageBlockInfo: BlockConfigBase = {
  id: 'mainImageBlock',
  title: 'Imagem Principal',
  icon: imageSVG,
  group: 'media',
  view: MainImageBlockView,
  edit: MainImageBlockEdit,
  blockSchema: MainImageSchema,
  restricted: ({ properties }) =>
    !properties.hasOwnProperty('preview_image_link'),
  mostUsed: false,
  sidebarTab: 1,
  blockHasOwnFocusManagement: false,
};

export default MainImageBlockInfo;
